module.exports = __webpack_public_path__ + "static/stone_of_controlling_earth_elementals-7ba3b4d71955b8b4f505ea7dece3910a.jpeg";